export default __webpack_public_path__ + "static/nomika_alodapis-73def6ffd9ab83a4627a605c9faef966.pdf";